/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // this is Fitle add to cart handler
  document.addEventListener('theme:product:add', function(evt) {
      let addedProduct = evt.detail.response;
      let product_id = addedProduct.product_id;
      if(!product_id){
          return ;
      }
      let size = ''
      size = addedProduct.variant_title;
      ftltag('event', 'cart', {
        product_id,size
      });
  });


  //mobile menu accordions
  var acc = document.getElementsByClassName("sliderow__panel-toggle");
  var i;

  for (i = 0; i < acc.length; i++) {
	acc[i].addEventListener("click", function() {
		this.classList.toggle("active");
		var panel = this.nextElementSibling;
		if (panel.style.maxHeight) {
			panel.style.maxHeight = null;
		} else {
			panel.style.maxHeight = panel.scrollHeight + "px";
		} 
	});
  }



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
